import React, { useId, useMemo } from "react";

const generateUniquePattern = (count = 5) => {
  const set = new Set();
  const result = [];

  while (result.length < count) {
    const x = Math.floor(Math.random() * 4) + 7; // 7-10
    const y = Math.floor(Math.random() * 6) + 1; // 1-6
    const key = `${x}-${y}`;

    if (!set.has(key)) {
      set.add(key);
      result.push([x, y]);
    }
  }

  return result;
};

export const Grid = React.memo(({ pattern, size }) => {
  // const p = pattern ?? [
  //   [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
  //   [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
  //   [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
  //   [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
  //   [Math.floor(Math.random() * 4) + 7, Math.floor(Math.random() * 6) + 1],
  // ];

  const p = useMemo(() => pattern ?? generateUniquePattern(5), [pattern]);
  return (
    <div className="pointer-events-none absolute left-1/2 top-0  -ml-20 -mt-2 h-full w-full [mask-image:linear-gradient(white,transparent)]">
      <div className="absolute inset-0 bg-gradient-to-r  [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] from-zinc-900/30  to-zinc-900/30 opacity-100">
        <GridPattern
          width={size ?? 20}
          height={size ?? 20}
          x="-12"
          y="4"
          squares={p}
          className="absolute inset-0 h-full w-full  mix-blend-overlay fill-white/10 stroke-white/10 stroke-black/10 fill-black/10"
        />
      </div>
    </div>
  );
});
Grid.displayName = "Grid";

export const GridPattern = React.memo(({ width, height, x, y, squares, ...props }) => {
  const patternId = useId();

  return (
    <svg aria-hidden="true" {...props}>
      <defs>
        <pattern
          id={patternId}
          width={width}
          height={height}
          patternUnits="userSpaceOnUse"
          x={x}
          y={y}
        >
          <path d={`M.5 ${height}V.5H${width}`} fill="none" />
        </pattern>
      </defs>
      <rect
        width="100%"
        height="100%"
        strokeWidth={0}
        fill={`url(#${patternId})`}
      />
      {squares && (
        <svg x={x} y={y} className="overflow-visible">
          {squares.map(([x, y]) => (
            <rect
              strokeWidth="0"
              key={`${x}-${y}`}
              width={width + 1}
              height={height + 1}
              x={x * width}
              y={y * height}
            />
          ))}
        </svg>
      )}
    </svg>
  );
});
GridPattern.displayName = "GridPattern";
